export const AVAILABILITY_CHOICES = [
  'Any day / time',
  'Weekdays — anytime',
  'Weekday mornings',
  'Weekday evenings',
  'Weekends — anytime',
  'Weekend mornings',
  'Weekend evenings',
  'Evenings — anytime',
] as const;

export const MENTORSHIP_MODES = ['Online', 'Offline', 'Any'] as const;
